const LAND_PROPERTY_TYPES = ['Lot / Land']

export const isLandPropertyType = status =>
  LAND_PROPERTY_TYPES.indexOf(status) > -1
